import React, { useState } from 'react';
import { FiAlertTriangle, FiAlertCircle } from 'react-icons/fi';
import { toast } from '../Toast';
import { useClient } from './clientSettingsData';
import SettingsModal from './SettingsModal';

interface Props {
    onClose: () => void;
}

// Billing › Request Cancellation. UI only: nothing is sent to the account manager yet
const CancelSubscriptionModal: React.FC<Props> = ({ onClose }) => {
    const { short } = useClient();
    const [reason, setReason] = useState('');
    const [understood, setUnderstood] = useState(false);

    const send = () => {
        toast.info('Preview only: this isn’t connected yet, so no request was sent');
        onClose();
    };

    return <SettingsModal danger icon={<FiAlertTriangle />} title="Cancel the Subscription" sub={`Ends ${short}'s Investi plan at the end of the year`} onClose={onClose}
        cancelLabel="Keep My Plan"
        footerNote="Goes to your account manager and accounts@investi.com.au"
        footer={<button type="button" className="btn-danger" onClick={send} disabled={!understood}>Request Cancellation</button>}>
        <ul className="bullets">
            <li>The plan keeps running until <strong>1 September 2027</strong>, then stops. There's no refund for the current year.</li>
            <li>Announcement emails, widgets and the Website Hub stop on that date.</li>
            <li>Your registry, contacts and email history stay for 12 months in case you come back.</li>
        </ul>
        <label className="field">
            <span className="label">Why are you leaving? <em>(optional)</em></span>
            <textarea rows={3} value={reason} onChange={e => setReason(e.target.value)} />
        </label>
        <label className="confirm">
            <input type="checkbox" checked={understood} onChange={e => setUnderstood(e.target.checked)} />
            <span>I understand the plan ends on 1 September 2027</span>
        </label>
        <div className="modal-note warn"><FiAlertCircle /> Nothing changes until your account manager confirms by email.</div>
    </SettingsModal>;
};

export default CancelSubscriptionModal;
